import useLayoutQuery from "../queries/branch/useLayoutQuery";

const useBranches = () => {
  return useLayoutQuery()?.data?.branches ?? [];
};

export default useBranches;
